var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"}));
}

Search.defaultProps = {"className":"fill-current pointer-events-none text-gray-600","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Search;

Search.default = Search;
